import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import {AvailableSlot} from "../data/Slot";
import {NewBooking} from "../data/Booking";
import {Button} from "primereact/button";
import {useEffect, useState} from "react";
import {InputTextarea} from "primereact/inputtextarea";
import {classNames} from "primereact/utils";
import {format} from "date-fns";
import {Panel} from "primereact/panel";

function ContactComponent({
                              selectedSlot,
                              isSubmitting,
                              onSubmitClicked,
                          }: {
    selectedSlot: AvailableSlot;
    isSubmitting: boolean;
    onSubmitClicked(booking: NewBooking): void;
}) {
    const [name, setName] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [amount, setAmount] = useState<number>(1);
    const [comment, setComment] = useState<string>("");

    useEffect(() => {
        if (amount > selectedSlot.available) setAmount(selectedSlot.available);
    }, [amount, selectedSlot.available]);

    const header = `Uhrzeit: ${format(selectedSlot.startDateTime, "HH:mm")} - ${format(selectedSlot.endDateTime, "HH:mm")}`;

    return (
        <Panel header={header}>
            <div className="p-fluid mb-5 mt-3">
        <span className="p-float-label">
          <InputText
              id="name"
              value={name}
              maxLength={128}
              onChange={(e) => setName(e.target.value)}
              className={"w-full " + classNames({"p-invalid": !name.trim()})}
          />
          <label htmlFor="name">Name</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <InputText
              id="phone"
              value={phone}
              maxLength={128}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full"
          />
          <label htmlFor="phone">Telefonnummer</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <InputText
              id="email"
              value={email}
              maxLength={128}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              className="w-full"
          />
          <label htmlFor="email">E-Mail</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <InputNumber
              id="amount"
              value={amount}
              onChange={(e) => setAmount(e.value!)}
              min={Math.min(1, selectedSlot.available)}
              max={selectedSlot.available}
              showButtons
              step={1}
              className="w-full"
          />
          <label htmlFor="amount">Plätze</label>
        </span>
            </div>

            <div className="p-fluid mb-5">
        <span className="p-float-label">
          <InputTextarea
              id="comment"
              value={comment}
              maxLength={512}
              onChange={(e) => setComment(e.target.value)}
              rows={5}
              cols={30}
              className="w-full"
          />
          <label htmlFor="comment">Kommentar</label>
        </span>
            </div>

            <div>
                <p className="text-xs pr-5 pl-5">
                    Mit dem Absenden des Termins erklärst du dich einverstanden,
                    <br/>
                    dass deine Daten zum Zweck der Buchung und eventuellen Rückfragen
                    gespeichert werden.
                </p>
            </div>

            <Button
                label="Buchen"
                disabled={!name.trim() || amount === 0}
                onClick={() => {
                    const booking = new NewBooking(
                        name,
                        amount,
                        selectedSlot.id,
                        phone,
                        email,
                        comment,
                    );
                    onSubmitClicked(booking);
                }}
                className="mt-3"
                loading={isSubmitting}
            />
        </Panel>
    );
}

export default ContactComponent;
